module.exports = __webpack_public_path__ + "static/img/2.afe7f31.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/7/2.png
// module id = 280
// module chunks = 0